import { render, staticRenderFns } from "./ContainerTags.vue?vue&type=template&id=7886bf93&scoped=true"
import script from "./ContainerTags.vue?vue&type=script&lang=js"
export * from "./ContainerTags.vue?vue&type=script&lang=js"
import style0 from "./ContainerTags.vue?vue&type=style&index=0&id=7886bf93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7886bf93",
  null
  
)

export default component.exports